/**
 * Build-time configuration injected by Vite's `define`.
 *
 * - Development: backend URL defaults to localhost; verbose logs.
 * - Production: backend URL baked in at build time from VITE_PROD_BACKEND_URL.
 *
 * No shared secret here — admin authenticates by constructing an
 * `admin:<name>:<deviceId>` token client-side and storing it in localStorage.
 * The backend only checks the `admin:` prefix in M1.
 */

declare const __PROD_BACKEND_URL__: string;
declare const __BUILD_MODE__: string;
declare const __BUILD_ID__: string;

const PROD_BACKEND_URL = __PROD_BACKEND_URL__;
const BUILD_MODE = __BUILD_MODE__;

/** Baked in by the Vite build. Dev and tests have no version.json, so this stays unused. */
export const buildId = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

export const isProduction = BUILD_MODE === 'production';

export const backendBaseUrl = isProduction
  ? PROD_BACKEND_URL || window.location.origin
  : 'http://localhost:3000';

export function log(...args: unknown[]): void {
  if (!isProduction) {
    console.log('[admin]', ...args);
  }
}
